import { createContext, useContext, useEffect, useState } from "react";
import { adminMe, tokenStore } from "../lib/adminApi";

const AdminAuthContext = createContext({
  admin: null,
  loading: true,
  refresh: () => {},
  logout: () => {},
});

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!tokenStore.get()) {
      setAdmin(null);
      setLoading(false);
      return null;
    }
    try {
      const me = await adminMe();
      setAdmin(me);
      return me;
    } catch {
      setAdmin(null);
      tokenStore.clear();
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    tokenStore.clear();
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, refresh, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
